export type { TotalArticlesQuery as TotalArticles } from 'graphql/__generated__/operations/TotalArticlesQuery';

export type { AllArticlesPaginatedQuery as AllArticlesPaginated } from 'graphql/__generated__/operations/AllArticlesPaginatedQuery';

export type { AllArticlesFromCategoryQuery as AllArticlesFromCategory } from 'graphql/__generated__/operations/AllArticlesFromCategoryQuery';
export type { CategoryNameQuery as CategoryName } from 'graphql/__generated__/operations/CategoryNameQuery';
export type { CategoriesDropdownQuery as CategoriesDropdown } from 'graphql/__generated__/operations/CategoriesDropdownQuery';
export type { CategoriesWithArticleTotals } from 'graphql/__generated__/operations/CategoriesWithArticleTotals';
export type { CategoryWithArticlesTotalQuery as CategoryWithArticlesTotal } from 'graphql/__generated__/operations/CategoryWithArticlesTotalQuery';

export type DynamicRoutes = string[][];
export type PaginationUrls = Array<string>;

export enum SORT_MODE {
  MOST_RECENT = 'most-recent',
  READ_TIME = 'read-time',
}

export type SortModeType = SORT_MODE.MOST_RECENT | SORT_MODE.READ_TIME;

export interface DropdownItem {
  id: string;
  label: string;
}

/**
 * This is what is needed from the ZDS Dropdown
 */
export type CategoriesDropdownItem = DropdownItem;

export interface SortModeDropdownItem extends DropdownItem {
  id: SortModeType;
}
